import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=574643b8"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"
import style0 from "./agenda.vue?vue&type=style&index=0&id=574643b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports